import React from 'react';
import { FaPen as EditIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import type { ScenarioDetailRow } from '@queries/scenarios';
import ValidationMessagesCellRenderer from '../../../shared/gridEdit/validationMessagesCellRenderer.component';
import { isEditingMode, RowWithMetadata } from '../../../shared/gridEdit/useEditableGridLogic';
import { getScenarioReportRowDetailId } from './utils';
import type { DetailsGridCellRendererParams, OnRemoveDetailsClick } from './types';

const isRowBeingEdited = (row: RowWithMetadata<ScenarioDetailRow>, editedRowId: string | null) =>
  getScenarioReportRowDetailId(row) === editedRowId;

export const DetailAdminColumnRenderer = (
  props: DetailsGridCellRendererParams & {
    removeRow: OnRemoveDetailsClick,
  }
) => {
  const {
    data: scenarioDetailsRow,
    context: {
      mode,
      editedRowId,
      isFunctionalCurrencySelected,
      isAnyDetailEditable,
    },
    node,
    editRow,
    removeRow,
  } = props;

  const onEditClick = () => {
    editRow(scenarioDetailsRow, node);
  };

  const onDeleteClick = () => {
    removeRow({ scenarioDetailsRow, node });
  };

  const areButtonsDisabled = isEditingMode(mode) || !isAnyDetailEditable;

  if (node.isRowPinned()) {
    return null;
  }

  if (isEditingMode(mode) && isRowBeingEdited(scenarioDetailsRow, editedRowId)) {
    return <ValidationMessagesCellRenderer {...props}/>;
  }

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Scenario Obligation"
        onClick={onEditClick} // eslint-disable-line react/jsx-no-bind
        disabled={areButtonsDisabled || !isFunctionalCurrencySelected}
      >
        <EditIcon
          size={16}
          className="cell-icon disabled-visible"
          data-tip={!isFunctionalCurrencySelected ? 'Editing is disabled, when functional currency is not selected' : ''}
        />
      </button>
      <button
        className="cell-icon-button"
        title="Remove Scenario Obligation"
        onClick={onDeleteClick} // eslint-disable-line react/jsx-no-bind
        disabled={areButtonsDisabled}
      >
        <TrashIcon size={16} className="cell-icon disabled-visible" />
      </button>
    </div>
  );
};
